import Vue from 'vue';
import VueNotification from 'vue-notification';
import { actionTypes } from '@/store/types';
import App from './App';
import store from './store';
import router from './router';

Vue.use(VueNotification);

Vue.config.productionTip = false;

(async () => {
  await store.dispatch(actionTypes.sessionNS.recall);
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
  });
})();



// WEBPACK FOOTER //
// ./src/main.js